export async function writeClipboardText(text: string): Promise<void> {
	return await navigator.clipboard.writeText(text);
}